import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import {
	FlatRowTextarea,
	type FlatRowTextareaProps,
} from "web_myplann/Shared/Components/FlatRow/FlatRowTextarea";

type Props<FormType extends FieldValues, TName> = Omit<
	FlatRowTextareaProps,
	"value" | "onChange" | "onBlur" | "inputRef" | "error" | "helperText"
> & {
	control: Control<FormType>;
	name: TName;
};

export const FlatRowFormTextarea = <
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
>({
	control,
	name,
	...rest
}: Props<FormType, TName>) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({
				field: { value, onChange, onBlur, ref },
				fieldState: { error },
			}) => (
				<FlatRowTextarea
					{...rest}
					value={value ?? ""}
					onChange={onChange}
					onBlur={onBlur}
					inputRef={ref}
					error={!!error?.message}
					helperText={error?.message}
				/>
			)}
		/>
	);
};
